export default "__VITE_ASSET__jRTg4Kbs__"